import React from 'react';
import { skills } from '../../mock';

const SkillsSection = () => {
  // Split skills into core and also strong
  const coreSkills = skills.slice(0, 6);
  const alsoStrongSkills = skills.slice(6);

  return (
    <section id="skills" className="py-24 px-6 bg-[#1A1430]/30">
      <div className="max-w-5xl mx-auto">
        <h2 className="text-center mb-16">What I bring</h2>
        
        {/* Core Skills */}
        <div className="mb-12">
          <h3 className="text-lg font-semibold text-[#EDE9FE] mb-6 text-center">Core</h3>
          <div className="flex flex-wrap gap-3 justify-center">
            {coreSkills.map((skill) => (
              <span
                key={skill.name}
                className="px-5 py-2.5 bg-[#7C3AED]/10 text-[#EDE9FE] rounded-full border border-[#7C3AED]/20 hover:bg-[#7C3AED]/20 hover:border-[#7C3AED]/40 transition-all duration-300 font-medium"
              >
                {skill.name}
              </span>
            ))}
          </div>
        </div>
        
        {/* Also Strong */}
        <div>
          <h3 className="text-lg font-semibold text-[#9D97B5] mb-6 text-center">Also strong</h3>
          <div className="flex flex-wrap gap-3 justify-center">
            {alsoStrongSkills.map((skill) => (
              <span
                key={skill.name}
                className="px-5 py-2.5 bg-[#1A1430] text-[#9D97B5] rounded-full border border-[#7C3AED]/10 hover:text-[#EDE9FE] hover:border-[#7C3AED]/20 transition-all duration-300"
              >
                {skill.name}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default SkillsSection;
